import React from 'react'
import Advantage from '../components/Advantage/Advantage'
import Advantage1 from '../components/Advantage1/Advantage1'
import Advantage2 from '../components/Advantage2/Advantage2'
import Advantage3 from '../components/Advantage3/Advantage3'
import Advantage4 from '../components/Advantage4/Advantage4'
import Advantage5 from '../components/Advantage5/Advantage5'

const Advantages = () => {
  return (
    <div className='advantages'>
        <Advantage/>
        <Advantage1/>
        <Advantage2/>
        <Advantage3/>
        <Advantage4/>
        <Advantage5/>
    </div>
  )
}

export default Advantages